/* Native Shopify theme compositor. No provider calls, credentials or uploads. */
(function(root){
  'use strict';
  function layout(bounds,frame,variant){
    const n=bounds.length;
    if(n<3||n>12) throw Error('SET_COVER_COUNT_INVALID');
    if(bounds.some(b=>!Number.isFinite(b.width)||!Number.isFinite(b.height)||b.width<=0||b.height<=0)) throw Error('SET_COVER_BOUNDS_INVALID');
    if(!frame){
      const rows=n<=6?[n]:[Math.ceil(n/2),Math.floor(n/2)];
      let bottleHeight=n<=6?738:550;
      while(bottleHeight>100){
        let offset=0;
        const fits=rows.every(count=>{const used=bounds.slice(offset,offset+count).reduce((s,b)=>s+Math.round(b.width*bottleHeight/b.height),0)+20*(count-1);offset+=count;return used<=1280;});
        if(fits)break;bottleHeight--;
      }
      if(bottleHeight<=100)throw Error('SET_COVER_ASPECT_INVALID');
      const top=(1400-(bottleHeight*rows.length+40*(rows.length-1)))/2;
      let index=0;const result=[];
      rows.forEach((count,row)=>{
        const widths=bounds.slice(index,index+count).map(b=>Math.round(b.width*bottleHeight/b.height));
        let x=Math.floor((1400-widths.reduce((a,b)=>a+b,0)-20*(count-1))/2);
        widths.forEach(bottleWidth=>{result.push({x,y:top+row*(bottleHeight+40),width:bottleWidth,height:bottleHeight});x+=bottleWidth+20;index++;});
      });return result;
    }
    const width=frame.width,height=frame.height;
    if(!Number.isFinite(width)||!Number.isFinite(height)||width<=0||height<=0) throw Error('SET_COVER_FRAME_INVALID');
    const welcomeNine=variant==='welcome-nine'&&n===9;
    const welcomeTwelve=variant==='welcome-twelve'&&n===12;
    const welcomeGrid=welcomeNine||welcomeTwelve;
    const rows=welcomeNine?[4,5]:welcomeTwelve?[4,4,4]:n<=6?[n]:[6,n-6];
    const gap=Math.max(10,Math.round(width*.012));
    const rowGap=Math.max(20,Math.round(height*.035));
    const horizontalRoom=width*.94;
    let bottleHeight=Math.round(height*(rows.length===1?.82:welcomeNine?.41:welcomeTwelve?.27:.43));
    if(welcomeGrid)bottleHeight=Math.min(bottleHeight,Math.floor((height-Math.round(height*.08)-Math.round(height*.04)-rowGap*(rows.length-1))/rows.length));
    while(bottleHeight>100){
      let offset=0;
      const fits=rows.every(count=>{const used=bounds.slice(offset,offset+count).reduce((s,b)=>s+Math.round(b.width*bottleHeight/b.height),0)+gap*(count-1);offset+=count;return used<=horizontalRoom;});
      if(fits)break; bottleHeight--;
    }
    if(bottleHeight<=100)throw Error('SET_COVER_ASPECT_INVALID');
    const compositionHeight=bottleHeight*rows.length+rowGap*(rows.length-1);
    const top=welcomeGrid?Math.max(Math.round(height*.08),(height-compositionHeight)/2):(height-compositionHeight)/2;
    let index=0;const result=[];
    rows.forEach((count,row)=>{
      const widths=bounds.slice(index,index+count).map(b=>Math.round(b.width*bottleHeight/b.height));
      let x=Math.floor((width-widths.reduce((a,b)=>a+b,0)-gap*(count-1))/2);
      widths.forEach(bottleWidth=>{result.push({x,y:top+row*(bottleHeight+rowGap),width:bottleWidth,height:bottleHeight});x+=bottleWidth+gap;index++;});
    });return result;
  }
  function alphaBounds(data,width,height){
    let left=width,top=height,right=-1,bottom=-1,transparent=0;
    for(let y=0;y<height;y++)for(let x=0;x<width;x++){
      const a=data[(y*width+x)*4+3];if(a===0)transparent++;
      if(a>0){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
    }
    if(right<left||transparent<width*height*.1)throw Error('SET_COVER_TRANSPARENT_SOURCE_REQUIRED');
    return {x:left,y:top,width:right-left+1,height:bottom-top+1};
  }
  if(typeof module!=='undefined')module.exports={layout,alphaBounds};
  if(!root.document)return;
  // The PDP/collection and the shared cart can load this asset on the same page.
  if(root.customElements.get('wynch-set-cover'))return;
  const cache=new Map();
  function load(url){
    const parsed=new URL(url,location.href);
    if(parsed.protocol!=='https:'||!(parsed.hostname===location.hostname||parsed.hostname==='cdn.shopify.com'||parsed.hostname.endsWith('.shopify.com')))return Promise.reject(Error('SET_COVER_IMAGE_HOST_INVALID'));
    if(!cache.has(parsed.href)){
      const promise=new Promise((resolve,reject)=>{
        const img=new Image();img.crossOrigin='anonymous';
        const timeout=setTimeout(()=>{img.src='';reject(Error('SET_COVER_IMAGE_TIMEOUT'));},20000);
        img.onload=()=>{clearTimeout(timeout);if(!img.naturalWidth||img.naturalWidth*img.naturalHeight>16000000)reject(Error('SET_COVER_IMAGE_SIZE_INVALID'));else resolve(img);};
        img.onerror=()=>{clearTimeout(timeout);reject(Error('SET_COVER_IMAGE_LOAD_FAILED'));};img.src=parsed.href;
      });cache.set(parsed.href,promise);promise.catch(()=>cache.delete(parsed.href));
      if(cache.size>48)cache.delete(cache.keys().next().value);
    }return cache.get(parsed.href);
  }
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting){observer.unobserve(e.target);e.target.renderCover();}}),{rootMargin:'250px'});
  class Cover extends HTMLElement{
    connectedCallback(){if(this.dataset.state)return;this.dataset.state='waiting';observer.observe(this);}
    disconnectedCallback(){observer.unobserve(this);}
    async renderCover(){
      if(this.dataset.state!=='waiting')return;this.dataset.state='loading';
      try{
        const payload=JSON.parse(this.querySelector('script[type="application/json"]').textContent);
        if(Object.keys(payload).sort().join(',')!=='bottles,hero'||!Array.isArray(payload.bottles)||payload.bottles.length<3||payload.bottles.length>12||payload.bottles.some(s=>typeof s!=='string'||!s))throw Error('SET_COVER_INPUT_INVALID');
        const [hero,...images]=await Promise.all([payload.hero,...payload.bottles].map(load));
        const scratch=document.createElement('canvas');const ctx=scratch.getContext('2d',{willReadFrequently:true});
        const bounds=images.map(img=>{scratch.width=img.naturalWidth;scratch.height=img.naturalHeight;ctx.drawImage(img,0,0);return alphaBounds(ctx.getImageData(0,0,scratch.width,scratch.height).data,scratch.width,scratch.height);});
        const wide=Boolean(this.closest('.product-card-double'));
        const canvas=document.createElement('canvas');canvas.setAttribute('aria-hidden','true');
        if(wide){const rect=this.getBoundingClientRect();if(rect.width<=0||rect.height<=0)throw Error('SET_COVER_FRAME_UNAVAILABLE');canvas.height=1200;canvas.width=Math.round(canvas.height*rect.width/rect.height);}
        else{canvas.width=canvas.height=1400;}
        const positions=layout(bounds,wide?{width:canvas.width,height:canvas.height}:undefined,this.dataset.layout);
        const c=canvas.getContext('2d');c.imageSmoothingQuality='high';
        if(!wide){const side=Math.min(hero.naturalWidth,hero.naturalHeight);c.drawImage(hero,(hero.naturalWidth-side)/2,(hero.naturalHeight-side)/2,side,side,0,0,1400,1400);c.fillStyle='rgba(255,255,255,0.2784313725)';c.fillRect(0,0,1400,1400);}
        images.forEach((img,i)=>{const b=bounds[i],p=positions[i];c.drawImage(img,b.x,b.y,b.width,b.height,p.x,p.y,p.width,p.height);});
        this.append(canvas);this.dataset.state='ready';this.dispatchEvent(new CustomEvent('wynch:set-cover-ready',{bubbles:true,detail:{count:images.length}}));
      }catch(error){this.dataset.state='error';const status=document.createElement('span');status.className='wynch-set-cover-error';status.textContent=document.documentElement.lang.startsWith('de')?'Set-Vorschau nicht verfügbar':'Set preview unavailable';this.append(status);console.error('[WYNCH set cover]',error.message);}
    }
  }
  customElements.define('wynch-set-cover',Cover);
  class Loader extends HTMLElement{
    static get observedAttributes(){return ['data-handle'];}
    connectedCallback(){this.update();}
    attributeChangedCallback(){if(this.isConnected)this.update();}
    async update(){
      const handle=this.dataset.handle;if(handle===this.current)return;this.current=handle;this.replaceChildren();
      if(!handle||!/^[a-z0-9-]+$/.test(handle))return;
      try{
        const url=new URL(`${root.Shopify?.routes?.root||'/'}products/${handle}`,location.origin);url.searchParams.set('section_id','wynch-set-cover-data');
        const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw Error('SET_COVER_SECTION_LOAD_FAILED');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');const cover=doc.querySelector('wynch-set-cover');
        if(this.current===handle&&cover)this.append(document.importNode(cover,true));
      }catch(error){console.error('[WYNCH set cover]',error.message);}
    }
  }
  customElements.define('wynch-set-cover-loader',Loader);
})(typeof window==='undefined'?globalThis:window);
